var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: _vm.$style.status,
    style: _setup.styleVariables
  }, [_vm._v("\n  " + _vm._s(_vm.status.title) + " " + _vm._s(_vm.status.subtitle) + "\n")]);
};
var staticRenderFns = [];
export { render, staticRenderFns };